const binding = { modules: {}, dataActions: {} };

    (binding.modules['subscribe'] = {
        c: () => require('@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'subscribe',
        p: 'subscribe',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|sheikhzayedfestival|views|subscribe'] = {
                c: () => require('partner/themes/sheikhzayedfestival/views/subscribe.view.tsx'),
                cn: '__local__-__local__-subscribe'
            };
viewDictionary['@msdyn365-commerce-modules|subscribe|modules|subscribe|subscribe'] = {
                c: () => require('@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe.view.js'),
                cn: '@msdyn365-commerce-modules-subscribe-subscribe'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };